export const getPaymentStateLabel = (value) => {
    const normalizedValue = value?.replace(/_/g, ' ');

    const labelMap = {
        done: 'Bloqueado',
        cancel: 'Cancelado',
        draft: 'A autorizar',
        'paid out': 'Pagado',
        paid: 'Pagado',
        posted: 'Pagado',
        'to approve': 'A autorizar',
        sent: 'Cotización enviada',
        check: 'Revisado',
        purchase: 'Confirmado',
        confirmed: 'Confirmado',
        partial: 'Pagado parcialmente',
        reversed: 'Revertido',
        'not paid': 'Confirmado',
        'in payment': 'Confirmado',
    };

    return labelMap[normalizedValue] ?? normalizedValue;
};
